import { Arc, Circle, GeoIntersection, GeometryBase, Line, Point } from "tnbase";
import { BlockPrimitive, EventHandlerBase, Primitive, PrimitiveType, PythaEventDataChange, RenderItemType } from "pytha2";



/**
 * 生成轴线网点
 */
export class EventHandlerGenGridPoint extends EventHandlerBase {

    /**
     * 处理器默认运行入口
     * @param data 
     * @returns 
     */
    run(data = {}) {
        console.log('EventHandlerGenGridPoint run');
        /**
         * 步骤：
         * 找到所有的轴线（type为AxisLine的）
         * 找到所有网点（type为GridPoint的）
         * 两两之间求交，获得一组point
         * 新旧两组网点判断，两者的交集（相同的点）不处理，旧网点删除，新网点添加
         * 最后输出一组point，这组point为最终的结果，在外面需要完全替换
         */
        const storage = this.getPythaStorage();
        const mainPrimitiveList: Primitive[] = Object.keys(storage.primitiveStore.primitiveDict)?.map(key => storage.primitiveStore.primitiveDict[key]) || [];
        const tempPrimitiveList: Primitive[] = Object.keys(storage.primitiveStore.tempPrimitiveDict)?.map(key => storage.primitiveStore.tempPrimitiveDict[key]) || [];
        const primitives: Primitive[] = [...mainPrimitiveList, ...tempPrimitiveList];
        // 使用map去重
        const primitiveList = Array.from(new Map(primitives?.map(primitive => [primitive.uuid, primitive])).values());
        // 找到所有网点（type为GridPoint的）
        let gridPointPriList = primitiveList?.filter(item => item.type === "Point" && !item.lock) || [];
        // 最后交点的集合
        let intersections = [];

        for (let i = 0; i <= primitiveList.length - 1; i++) {
            const primitiveA = primitiveList[i]
            if (primitiveA.lock || primitiveA.type == "Text" || primitiveA.type == "MarkLine") {
                // 锁定的图元、文字、标注线 不求交
                continue;
            }
            let intersectionPointList: Point[] = [];
            let geosA = primitiveA.geos
            let worldModelMatrixA = primitiveA.worldModelMatrix
            if (worldModelMatrixA) {
                geosA.forEach(geo => {
                    geo.transformMatrix.premultiply(worldModelMatrixA)
                })
            }
            for (let j = i + 1; j < primitiveList.length; j++) {
                let primitiveB = primitiveList[j];
                if (primitiveB.lock || primitiveB.type == "Text") {
                    // 锁定的图元和文字不求交
                    continue;
                }
                let geosB = primitiveB.geos
                let worldModelMatrixB = primitiveB.worldModelMatrix
                if (worldModelMatrixB) {
                    geosB.forEach(geo => {
                        geo.transformMatrix.premultiply(worldModelMatrixB)
                    })
                }
                intersectionPointList.push(...this.getGeoIntersectionGeoPoints(geosA, geosB))
                if (worldModelMatrixB) {
                    let worldModelMatrixBInvert = worldModelMatrixB.clone().invert()
                    geosB.forEach(geo => {
                        geo.transformMatrix.premultiply(worldModelMatrixBInvert)
                    })
                }
            }
            if (worldModelMatrixA) {
                let worldModelMatrixAInvert = worldModelMatrixA.clone().invert()
                geosA.forEach(geo => {
                    geo.transformMatrix.premultiply(worldModelMatrixAInvert)
                })
            }
            // 把这些点加入
            intersectionPointList?.forEach(item => {
                this.pushPointToArray(intersections, item)
            })
        }

        // 新旧两组网点判断，两者的交集（相同的点）不处理，旧网点删除，新网点添加
        // 获取需要新增的点
        const needCreatePoints: Point[] = intersections?.reduce((result, newPoint) => {
            const idx = gridPointPriList?.findIndex(pri => pri?.getP()?.equals(newPoint));
            if (idx === -1) {
                // 不存在点坐标相同的点，属于新增点
                result.push(newPoint);
            } else {
                // 移除已经匹配的点
                gridPointPriList.splice(idx, 1);
            }
            return result;
        }, []);
        if (gridPointPriList?.length > 0) {
            gridPointPriList.forEach(primitive => {
                primitive.needDelete = true;
            })
        }
        if (needCreatePoints?.length > 0) {
            // 生成点图元
            let needCreatePris: Primitive[] = [];
            needCreatePoints.forEach(item => {
                let primitive = new Primitive("Point");
                primitive.move(item);
                this.addPrimitive(primitive);
                needCreatePris.push(primitive);
            })
        }



        // // 找到所有的轴线（type为AxisLine的）
        // const axisLinePriList = primitiveList?.filter(item => item.type === "AxisLine") || [];
        // // 找到所有网点（type为GridPoint的）
        // let gridPointPriList = primitiveList?.filter(item => item.type === "Point") || [];
        // if (axisLinePriList?.length === 0) {
        //     // 没有轴线，意味着没有新节点新增，可能有旧节点删除
        //     if (gridPointPriList?.length > 0) {
        //         // 存在旧节点需要删除，发删除信号
        //         gridPointPriList.forEach(primitive => {
        //             primitive.needDelete = true;
        //         })
        //     }
        //     return true;
        // }
        // // 两两之间求交，获得一组point
        // // 获取轴线的geo
        // let geoLineList = [];
        // axisLinePriList.forEach(linePri => {
        //     linePri.geos.forEach(geo => {
        //         if (geo.type === PrimitiveType.Line) {
        //             if (linePri.worldModelMatrix) {
        //                 const geoStart = (geo as Line).start.applyMatrix4(linePri.worldModelMatrix);
        //                 const geoEnd = (geo as Line).end.applyMatrix4(linePri.worldModelMatrix);
        //                 const line = new Line(geoStart, geoEnd);
        //                 geoLineList.push(line);
        //             } else {
        //                 geoLineList.push(geo);
        //             }
        //         }
        //     })
        // })
        // console.log('geoLineList', geoLineList)
        // // 获取网点
        // let intersections = [];
        // if (geoLineList?.length > 1) {
        //     for (let i = 0; i < geoLineList.length; i++) {
        //         for (let j = i + 1; j < geoLineList.length; j++) {
        //             const line1 = geoLineList[i];
        //             const line2: Line = geoLineList[j];
        //             // 计算两条线的交点
        //             const intersection = GeoIntersection.LineIntersectSegment(line1, line2.start, line2.end, true, true);
        //             if (!!intersection) {
        //                 this.pushPointToArray(intersections, intersection);
        //             }
        //         }
        //     }
        // }


        // // 新旧两组网点判断，两者的交集（相同的点）不处理，旧网点删除，新网点添加
        // // 获取需要新增的点
        // const needCreatePoints: Point[] = intersections?.reduce((result, newPoint) => {
        //     const idx = gridPointPriList?.findIndex(pri => pri?.getP()?.equals(newPoint));
        //     if (idx === -1) {
        //         // 不存在点坐标相同的点，属于新增点
        //         result.push(newPoint);
        //     } else {
        //         // 移除已经匹配的点
        //         gridPointPriList.splice(idx, 1);
        //     }
        //     return result;
        // }, []);
        // console.log('needCreatePoints', needCreatePoints)

        // console.log('gridPointPriList', gridPointPriList)
        // if (gridPointPriList?.length > 0) {
        //     gridPointPriList.forEach(primitive => {
        //         primitive.needDelete = true;
        //     })
        // }

        // if (needCreatePoints?.length > 0) {
        //     // 生成点图元
        //     let needCreatePris: Primitive[] = [];
        //     needCreatePoints.forEach(item => {
        //         let primitive = new Primitive("Point");
        //         primitive.move(item);
        //         this.addPrimitive(primitive);
        //         needCreatePris.push(primitive);
        //     })
        // }
        return true;
    }

    /**
     * 在数组中添加一个唯一元素
     * @param array 数组
     * @param point 元素
     */
    pushPointToArray(array: Point[], point: Point) {
        if (!array?.some(item => item.equals(point))) {
            array.push(point);
        }
    }

    /**
     * 添加一个点图元
     * @param primitive 
     * @param geos 
     */
    addPrimitive(primitive: Primitive) {
        const storage = this.getPythaStorage();
        primitive.geos = [];
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = [];
            // renderItem.mat.color.set(0xE54242);
            renderItem.mat?.color.set(storage.layerStore.getColor());
            renderItem.renderType = RenderItemType.POINT;
        }

        primitive.temporary = true;
        primitive.layerUuid = storage.layerStore.currentLayerUuid || null;
        primitive.colorByLayer = true;
        storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        primitive.needRedraw = true;
        this.node.graph.cache.primitiveList.push(primitive)
    }

    /**
     * 获取两组geo的交点集合
     * @param geosA 
     * @param geosB 
     * @returns 
     */
    getGeoIntersectionGeoPoints(geosA: GeometryBase[], geosB: GeometryBase[]): Point[] {
        if (!(geosA?.length > 0) || !(geosB?.length > 0)) return []
        let res: Point[] = []
        for (let i = 0; i < geosA.length; i++) {
            for (let j = 0; j < geosB.length; j++) {
                res.push(...this.getIntersctionPoints(geosA[i], geosB[j]))
            }
        }

        return res
    }

    /**
     * 获取线两两交点
     * @param geo1 
     * @param geo2 
     * @returns 
     */
    getIntersctionPoints(geo1: GeometryBase, geo2: GeometryBase): Point[] {
        if (geo1.type == "Line") {
            let lineGeo1 = geo1 as Line
            if (geo2.type == "Line") {
                let lineGeo2 = geo2 as Line
                let intersectionPoint = GeoIntersection.LineSegmentIntersection(lineGeo1.start, lineGeo1.end, lineGeo2.start, lineGeo2.end)
                if (intersectionPoint) {
                    return [intersectionPoint]
                } else {
                    return []
                }
            } else if (geo2.type == "Arc") {
                let arcGeo2 = geo2 as Arc
                let intersectionPoints: Point[] = GeoIntersection.ArcIntersectLine(arcGeo2, lineGeo1, true, true)
                return intersectionPoints
            } else if (geo2.type == "Circle") {
                let circleGeo2 = geo2 as Circle
                let intersectionPoints: Point[] = GeoIntersection.ArcIntersectLine(circleGeo2, lineGeo1, true, true)
                return intersectionPoints
            }
        } else if (geo1.type == "Arc") {
            let arcGeo1 = geo1 as Arc
            if (geo2.type == "Line") {
                let lineGeo2 = geo2 as Line
                let intersectionPoints: Point[] = GeoIntersection.ArcIntersectLine(arcGeo1, lineGeo2, true, true)
                return intersectionPoints
            } else if (geo2.type == "Arc") {
                let arcGeo2 = geo2 as Arc
                let intersectionPoints: Point[] = GeoIntersection.ArcIntersectArc(arcGeo1, arcGeo2, true, true)
                return intersectionPoints
            } else if (geo2.type == "Circle") {
                let circleGeo2 = geo2 as Circle
                let intersectionPoints: Point[] = GeoIntersection.ArcIntersectArc(arcGeo1, circleGeo2, true, true)
                return intersectionPoints
            }
        } else if (geo1.type == "Circle") {
            let circleGeo1 = geo1 as Circle
            if (geo2.type == "Line") {
                let lineGeo2 = geo2 as Line
                let intersectionPoints: Point[] = GeoIntersection.ArcIntersectLine(circleGeo1, lineGeo2, true, true)
                return intersectionPoints
            } else if (geo2.type == "Arc") {
                let arcGeo2 = geo2 as Arc
                let intersectionPoints: Point[] = GeoIntersection.ArcIntersectArc(circleGeo1, arcGeo2, true, true)
                return intersectionPoints
            } else if (geo2.type == "Circle") {
                let circleGeo2 = geo2 as Circle
                let intersectionPoints: Point[] = GeoIntersection.ArcIntersectArc(circleGeo1, circleGeo2, true, true)
                return intersectionPoints
            }
        }
        return []
    }
}